import React from 'react';
import {View} from 'MWC';
import SmallBanner from './smallBanner.c';
import DOMPurify from 'utils/sanitize';

class LogoLink extends View {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            menu,
            bannerCloseHandler,
            active,
            navigate,
            renderSubMenuItems,
            withoutColumnWidth,
            version
        } = this.props;

        if (!menu) return null;

        const bigBannerImg = menu.banner && (
            <>
                <img
                    src={menu.banner.bg}
                    alt={`${menu.alias} banner background`}
                    className='header-menu-banners-side__bg'
                />
                <div className='header-menu-banners-side__content'>
                    {menu.banner.img && (
                        <div className='header-menu-banners-side__img'>
                            <img
                                src={menu.banner.img}
                                alt={`${menu.alias} banner img`}
                                className='credit image pbp'
                            />
                        </div>
                    )}
                    <div className='header-menu-banners-side__title'>
                        {this.l10n(menu.banner.title)}
                    </div>
                    <div className='header-menu-banners-side__text'>
                        {this.l10n(menu.banner.text)}
                    </div>
                </div>
            </>
        );

        const firstTwoColumns = menu.columns.slice(0, 2);
        const restColumns = menu.columns.slice(2);

        return (
            <>
                {menu.smallBanners && (
                    <div className='header-menu-banners-side'>
                        {menu.smallBannersSubtitle && (
                            <div className='header-menu-subtitle'>
                                {this.l10n(menu.smallBannersSubtitle)}
                            </div>
                        )}
                        {menu.smallBanners.map((banner, index) => (
                            <SmallBanner
                                key={index}
                                href={banner.href}
                                closeMenuHandler={bannerCloseHandler}
                                img={banner.img}
                                title={this.l10n(banner.title)}
                                text={this.l10n(banner.text)}
                                navigate={navigate}
                            />
                        ))}
                    </div>
                )}
                <div className='sub-menu-items-wrapper'>
                    <>
                        <div className={`sub-menu-items sub-menu-items_${menu.alias}`}>
                            {firstTwoColumns.map((col, index) => (
                                <div className='sub-menu-item-wrapper' key={index}>
                                    <div
                                        style={!withoutColumnWidth ? {width: col.width} : undefined}
                                    >
                                        {col.subtitle && (
                                            <div
                                                className='header-menu-subtitle'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(col.subtitle)
                                                    )
                                                }}
                                            />
                                        )}
                                        {renderSubMenuItems(col.items, active)}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {restColumns.map((col, index) => (
                            <div className='sub-menu-item-wrapper' key={`rest-${index}`}>
                                <div style={!withoutColumnWidth ? {width: col.width} : undefined}>
                                    {col.subtitle && (
                                        <div
                                            className='header-menu-subtitle'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(this.l10n(col.subtitle))
                                            }}
                                        />
                                    )}
                                    {renderSubMenuItems(col.items, active)}
                                </div>
                            </div>
                        ))}
                    </>
                </div>
                {menu.banner && (version !== 'tablet' || menu.alias === 'credit') && (
                    <div
                        className={`header-menu-banners-side header-menu-banners-big ${menu.alias}`}
                    >
                        <a
                            href={menu.banner.href}
                            onClick={e => {
                                if (menu.banner.target == '_self') {
                                    navigate(menu.banner.href, e);
                                    bannerCloseHandler();
                                }
                            }}
                            onKeyDown={e => {
                                if (menu.banner.target === '_blank') {
                                    e.key === 'Enter' && window.open(menu.banner.href, '_blank');
                                }
                            }}
                            tabIndex={menu.banner.target === '_blank' && '0'}
                            target={menu.banner.target}
                        >
                            {bigBannerImg}
                        </a>
                    </div>
                )}
            </>
        );
    }
}

export default LogoLink;
